import Technology1 from "./Technology1.template";
import Technology2 from "./Technology2.template";

export default [Technology1, Technology2];
